module.exports = __webpack_public_path__ + "img/wechat.85b5480.svg";